// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/css/reset.css";
import "../src/assets/css/font.css";
import Plugin from "v-fit-columns";
Vue.use(Plugin);
// import './assets/css/adaptive.css'
// import './assets/css/publicStyle.css'
// import './assets/css/commonality.css'
// import './api/saleApi.js'
import locale from "element-ui/lib/locale/lang/en";
Vue.use(ElementUI, { locale });
import Vuex from "vuex";
Vue.use(Vuex);

import axios from "axios";
import VueIntercom from "vue-intercom";

import horizontalScroll from "el-table-horizontal-scroll";
Vue.use(horizontalScroll);

import store from "./store";

Vue.prototype.$http = axios; //其他页面在使用axios的时候直接  this.$http就可以了

import vueQuillEditor from "vue-quill-editor"; //富文本
Vue.use(vueQuillEditor);

Vue.use(VueIntercom, { appId: "uu6ddns6" });

import _ from "../src/assets/js/myfunction";
router.beforeEach((to, from, next) => {
  var controlrouter = store.state.controlrouter;
  if (to.path == "/lead_qr_form" || to.path == "/lead_capture_form") {
    return next();
  }
  // console.log('controlrouter:',controlrouter)
  var excludes = [
    "/",
    "/login",
    "/changePassword",
    "/forgotPassword",
    "/resetPassword",
    "/dashboard",
    "/DownloadApp",
    "/lead_qr_form",
    "/lead_capture_form",
  ];
  if (!excludes.includes(to.path) && JSON.stringify(controlrouter) != "{}") {
    var path = "";
    // controlrouter.hasOwnProperty(to.path)
    if (controlrouter.hasOwnProperty(to.path)) {
      path = to.path;
    } else {
      for (var ele in controlrouter) {
        if (to.path.startsWith(ele)) {
          path = ele;
          break;
        }
      }
    }
    // console.log('path',path)
    if (path == "" || controlrouter[path] == "01") {
      next({
        path: "/index",
      });
    }
  }

  window.scrollTo(0, 0);
  // console.log("?testT",to,to.meta)
  if (to.meta.Auth) {
    // 判断该路由是否需要登录权限
    if (sessionStorage.getItem("token")) {
      // 通过sessionStorage获取当前的token是否存在
      next();
    } else {
      var agencyid = null;
      var languagetype = null;
      if (localStorage.getItem("userInfo")) {
        var userInfo = JSON.parse(localStorage.getItem("userInfo"));
        agencyid = userInfo.agencyid;
        languagetype = userInfo.languagetype;
      }
      if (agencyid) {
        next({
          path: "/login",
          query: {
            agencyid: agencyid,
            languagetype: languagetype,
            redirect: to.fullPath,
          }, // 将跳转的路由path作为参数，登录成功后跳转到该路由
        });
      } else {
        next({
          path: "/login",
          query: { redirect: to.fullPath }, // 将跳转的路由path作为参数，登录成功后跳转到该路由
        });
      }
    }
  } else {
    next();
  }
});

import global from "../src/assets/js/global.js";
import popNav from "@/assets/js/navPopup.js";

// naviPop();
// popNav();
Vue.prototype.popNav = popNav;
// Vue.prototype.test = test;

// Vue.prototype.naviPopup = function (){
//     naviPop();
// }

// this.naviPopup();
// this.naviPop();
// naviPop();

import tldjs from "tldjs";
if (global.environment == "market" || global.environment == "enterprice") {
  var host = tldjs.getDomain(location.host);
  // var host = "arcnet.com.au";
  axios.defaults.baseURL = `https://service.${host}/arc-agency-end/`;
  location.clientWebURL = "client." + host;
  location.webURL = `https://agency.${host}`;
  location.socketURL = `wss://service.${host}:8443/arc-agency-end/`;
  location.downloadApp = `https://agency.${host}/`;
  location.downloadVerifyURL = `https://agency.${host}/downloadVerify?downloadlink=`;
  location.agentWebURL = `https://agent.${host}/`;
  location.domainAuthURL =
    "https://auth.domain.com.au/v1/connect/authorize?" +
    "client_id=client_ee17ade4f13ba7579694a4c535e58239" +
    "&redirect_uri=https://service.arcnet.com.au/arc-agency-end/domain/callback";
  location.frameworkURL = "https://crt-fwapi.azure-api.net/Prod-CRT-FworkCRM/job";
  location.crossubURL = "https://agent.crossub.com.au/api/v1/OpenApi/";
  Vue.prototype.$framework_apikey = "21944f46107849b1a48dc0f6c1838a63";
  Vue.prototype.$stripe_apikey = "pk_live_veWrShz0ziOSkjWS35eA4HRT00flKi2CVS";
} else if (global.environment == "staging") {
  var host = tldjs.getDomain(location.host);
  // var host = "arcnet.com.au";
  axios.defaults.baseURL = `https://staging.${host}/arc-agency-end/`;
  location.clientWebURL = "client-staging." + host;
  location.webURL = `https://agency-staging.${host}`;
  location.socketURL = `wss://staging.${host}:8443/arc-agency-end/`;
  location.downloadApp = `https://agency-staging.${host}/`;
  location.downloadVerifyURL = `https://agency-staging.${host}/downloadVerify?downloadlink=`;
  location.agentWebURL = `https://agent-staging.${host}/`;
  location.domainAuthURL =
    "https://auth.domain.com.au/v1/connect/authorize?" +
    "client_id=client_33ac125a4b90792eb424b4c19c8bb6d5" +
    "&redirect_uri=https://staging.arcnet.com.au/arc-agency-end/domain/callback";
  location.frameworkURL = "https://crt-fwapi.azure-api.net/Preprod-CRT-FworkCRM/job";
  location.crossubURL = "https://agent.crossub.com.au/api/v1/OpenApi/";
  Vue.prototype.$framework_apikey = "b12da56100234b98aea19c5c6caed378";
  Vue.prototype.$stripe_apikey = "pk_test_M3w648L5uJ3WVqju5j6f9buR00YidNfXP1";
} else {
  axios.defaults.baseURL = "http://localhost:8088/";
  location.clientWebURL = "client-staging.arcnet.com.au";
  location.webURL = "http://localhost:8091";
  location.socketURL = "ws://localhost:8088/";
  location.downloadApp = "http://localhost:8088/";
  location.downloadVerifyURL = "http://localhost:8088/downloadVerify?downloadlink=";
  location.agentWebURL = `https://agent-staging.arcnet.com.au/`;
  location.domainAuthURL =
    "https://auth.domain.com.au/v1/connect/authorize?" +
    "client_id=client_33ac125a4b90792eb424b4c19c8bb6d5" +
    "&redirect_uri=https://staging.arcnet.com.au/arc-agency-end/domain/callback";
  location.frameworkURL = "https://crt-fwapi.azure-api.net/Preprod-CRT-FworkCRM/job";
  location.crossubURL = "https://agent.crossub.com.au/api/v1/OpenApi/";
  Vue.prototype.$framework_apikey = "b12da56100234b98aea19c5c6caed378";
  Vue.prototype.$stripe_apikey = "pk_test_M3w648L5uJ3WVqju5j6f9buR00YidNfXP1";
}

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
// import 'quill/dist/quill.bubble.css'
import "font-awesome/css/font-awesome.css"; //Font-awesome 图标
import "../src/assets/css/common.scss"; //公共样式 有需要自己建
// import echarts from 'echarts'
import * as echarts from "echarts";

Vue.prototype.$echarts = echarts;

import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);

import vueEsign from "vue-esign";
Vue.use(vueEsign);

import moment from "moment";
Vue.prototype.$moment = moment;

import "../src/svgIcon/index";
import "../src/components/ui/index";

Vue.prototype.$socket = null;

import lottie from "vue-lottie";
Vue.component("lottie", lottie);

// Vue.use(vueQuillEditor);
import VueDND from "awe-dnd";
Vue.config.productionTip = false;
Vue.use(VueDND);
new Vue({
  el: "#app",
  router,
  store,
  components: {
    App,
    router,
  },
  template: "<App/>",
});

// import 'vuetify/styles'
// import vuetify from 'vuetify'
// import { createVuetify } from '@/vuetify'
// import * as components from '@/vuetify/components'
// import * as directives from '@/vuetify/directives'

// const vuetify = createVuetify({
//   components,
//   directives,
// })

// Vue.use(vuetify)

Vue.prototype.isJLL = function () {
  var host = tldjs.getDomain(location.host);
  return host && global.jll.includes(host);
};

Vue.prototype.isJLLR = function () {
  var host = tldjs.getDomain(location.host);
  return host && host === global.jll[1];
};

Vue.prototype.isCreationHome = function (agencyid) {
  return global.creationhome.includes(agencyid);
};

Vue.prototype.isBillbergia = function (agencyid) {
  return global.billbergia.includes(agencyid);
};

Vue.prototype.isKoham = function (agencyid) {
  return global.koham.includes(agencyid);
};


// WEBPACK FOOTER //
// ./src/main.js